export const OBTENER_PARTIDOS = 'partidos_traer_todas';
export const ERROR = 'partidos_error';
export const LOADING = 'partidos_loading';